const middleware = {}

middleware['authed'] = require('../middleware/authed.js')
middleware['authed'] = middleware['authed'].default || middleware['authed']

middleware['routeHelper'] = require('../middleware/routeHelper.js')
middleware['routeHelper'] = middleware['routeHelper'].default || middleware['routeHelper']

export default middleware
